import React, { useContext, useEffect, useState } from "react";
import { confirm } from "./Confirmation";
import classNames from "classnames";

const WizardContext = React.createContext({
    page: 0,
    setPage: () => {
        console.log("provide implementation");
    },
    canNext: true,
    setCanNext: () => {
        console.log("provide implementation");
    },
    canBack: false,
    setCanBack: () => {
        console.log("provide implementation");
    },
    manifest: {},
    setManifest: () => {
        console.log("provide implementation");
    },
    show: false,
    setShow: () => {
        console.log("provide implementation");
    },
    title: "Wizard",
    setTitle: () => {
        console.log("provide implementation");
    },
    moveNext: () => {
        console.log("provide implementation");
    },
    moveBack: () => {
        console.log("provide implementation");
    },
    onClose: () => {
        console.log("provide implementation");
    },
    finish: () => {
        console.log("provide implementation");
    },
});

const WizardContextProvider = (props) => {
    console.log("WizardContextProvider", props);
    const pageCount = () => {
        return Array.isArray(props.children) ? props.children.length : 1;
    };
    const moveNext = () => {
        const fn = props.children[currentPage]?.props?.onNextRequested;
        const event = new CustomEvent("onNextRequsted", {
            detail: {
                manifest,
            },
            bubbles: false,
        });
        fn && fn(event);
        if (event.detail.prevented) {
            return;
        }
        setManifest(event.detail.manifest);
        setCurrentPage(currentPage + 1);
    };
    const moveBack = () => {
        const fn = props.children[currentPage]?.props?.onBackRequested;
        const event = new CustomEvent("onBackRequested", {
            detail: {
                manifest,
            },
            bubbles: false,
        });
        fn && fn(event);
        if (event.detail.prevented) {
            return;
        }
        setManifest(event.detail.manifest);
        setCurrentPage(currentPage - 1);
    };
    const finish = () => {
        const fn = props.onFinish;
        const event = new CustomEvent("onFinish", {
            detail: {
                manifest,
            },
            bubbles: false,
        });
        fn && fn(event);
        if (event.detail.prevented) {
            return;
        }
        setManifest(event.detail.manifest);
    };
    const onClose = () => {
        const fn = props.onClose;
        const event = new CustomEvent("onClose", {
            detail: {
                manifest,
            },
            bubbles: false,
        });
        fn && fn(event);
        if (event.detail.prevented) {
            return;
        }
        setManifest(event.detail.manifest);
    };
    const skip = () => {
        const fn = props.onClose;
        const event = new CustomEvent("onClose", {
            detail: {
                manifest,
            },
            bubbles: false,
        });
        fn && fn(event);
        if (event.detail.prevented) {
            return;
        }
        setManifest(event.detail.manifest);
    };

    const [title, setTitle] = useState("Wizard");
    const [show, setShow] = useState(false);
    const [manifest, setManifest] = useState(props.manifest || {});
    const [currentPage, setCurrentPage] = useState(0);
    const [canNext, setCanNext] = useState(false);
    const [canBack, setCanBack] = useState(false);
    const [canFinish, setCanFinish] = useState(false);
    const [canClose, setCanClose] = useState(props.canClose || true);

    useEffect(() => {
        setCanBack(currentPage > 0 && currentPage < pageCount());
        setCanNext(currentPage < pageCount() - 1);
        setCanFinish(currentPage === pageCount() - 1);
    }, [currentPage]);

    useEffect(() => {
        console.log("WizardContextProvider useEffect", manifest);
    }, [manifest]);

    return (
        <WizardContext.Provider
            value={{
                currentPage,
                setCurrentPage,
                canNext,
                setCanNext,
                canBack,
                setCanBack,
                canClose,
                setCanClose,
                manifest,
                setManifest,
                show,
                setShow,
                title,
                canFinish,
                setTitle,
                moveNext,
                moveBack,
                onClose,
                finish
            }}
        >
            <WizardView {...props}></WizardView>
        </WizardContext.Provider>
    );
};

function WizardView(props) {
    const wizardContext = useContext(WizardContext);
    console.log("wv", wizardContext);
    return  (
            <div
                role="dialog"
                aria-modal="true"
                className="fade modal show"
                tabIndex={-1}
                style={{ display: "block" }}
            >
                <div className="modal-xl modal-dialog-centered mx-auto">
                    <div className="modal-content">
                        <div className="modal-header bg-info">
                            <div className="modal-title h4">
                                {" "}
                                <h4>{wizardContext.title}</h4>
                            </div>{" "}
                            {wizardContext.canClose && (
                                <button
                                    type="button"
                                    className="close"
                                    onClick={async () => {
                                        if (
                                            (await confirm(
                                                "Cancelling this wizard will lead to loss of all changes. Are you sure you wish to continue?"
                                            )) === true
                                        ) {
                                            props.onClose();
                                        }
                                    }}
                                >
                                    <i className="fa fa-times nav-icon"></i>
                                </button>
                            )}
                        </div>
                        <div className="modal-body">
                            <section className="content">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="timeline">
                                            {props.children &&
                                                Array.isArray(props.children) &&
                                                props.children.map(
                                                    (page, index) => {
                                                        return (
                                                            <div key={index}>
                                                                <span
                                                                    className={classNames(
                                                                        "fas",
                                                                        {
                                                                            "bg-info":
                                                                                index ===
                                                                                wizardContext.currentPage,
                                                                            "bg-white":
                                                                                index !==
                                                                                wizardContext.currentPage,
                                                                            border:
                                                                                index !==
                                                                                wizardContext.currentPage,
                                                                            "border-info":
                                                                                index !==
                                                                                wizardContext.currentPage,
                                                                            "text-info":
                                                                                index <
                                                                                wizardContext.currentPage,
                                                                            [`fa-${page.props.icon}`]:
                                                                                index !==
                                                                                wizardContext.currentPage,
                                                                        }
                                                                    )}
                                                                ></span>
                                                                <div
                                                                    className={
                                                                        "timeline-item " +
                                                                        (index ==
                                                                        wizardContext.currentPage
                                                                            ? "bg-info"
                                                                            : "")
                                                                    }
                                                                >
                                                                    <h3
                                                                        className={classNames(
                                                                            "timeline-header",
                                                                            "text-sm",
                                                                            {
                                                                                "text-white":
                                                                                    index ===
                                                                                    wizardContext.currentPage,
                                                                                "text-info":
                                                                                    index ===
                                                                                    wizardContext.currentPage,
                                                                            }
                                                                        )}
                                                                    >
                                                                        {
                                                                            page
                                                                                .props
                                                                                .title
                                                                        }
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="container-fluid">
                                            {props.children &&
                                                Array.isArray(props.children) &&
                                                props.children.map(
                                                    (component, index) => {
                                                        return index ==
                                                            wizardContext.currentPage ? (
                                                            <>
                                                                <component.type
                                                                    key={index}
                                                                    {...component.props}
                                                                    manifest={
                                                                        wizardContext.manifest
                                                                    }
                                                                    onNextRequested={
                                                                        component
                                                                            .props
                                                                            .onNextRequested
                                                                    }
                                                                    onBackRequested={
                                                                        component
                                                                            .props
                                                                            .onBackRequested
                                                                    }
                                                                ></component.type>
                                                            </>
                                                        ) : (
                                                            <></>
                                                        );
                                                    }
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="modal-footer">
                            <div className="col-4">
                                {props.children[wizardContext.currentPage]
                                    ?.props?.skippable && (
                                    <>
                                        <button
                                            className="btn btn-sm btn-warning"
                                            onClick={() => {
                                                wizardContext.moveNext();
                                            }}
                                        >
                                            Skip
                                        </button>
                                    </>
                                )}
                                <button
                                    className="btn btn-sm btn-info btn-primary m-2"
                                    onClick={() => {
                                        wizardContext.moveBack();
                                    }}
                                    disabled={!wizardContext.canBack}
                                >
                                    Back
                                </button>
                                {wizardContext.canFinish ? (
                                    <>
                                        <button
                                            className="btn btn-sm btn-info btn-primary"
                                            onClick={() => {
                                                wizardContext.finish();
                                            }}
                                        >
                                            Finish
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button
                                            className="btn btn-sm btn-info btn-primary"
                                            onClick={() => {
                                                wizardContext.moveNext();
                                            }}
                                            disabled={!wizardContext.canNext}
                                        >
                                            Next
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

const Page = (props) => {
    return <>{props.children}</>;
};

WizardView.Page = Page;

function Wizard(props) {
    return (
        <WizardContextProvider value={{}}>
            <WizardView {...props}></WizardView>
        </WizardContextProvider>
    );
}

export { Wizard, WizardView, WizardContext, WizardContextProvider };
